import { computed } from '@vue/composition-api';
import { useStore } from '@nuxtjs/composition-api';
import { SubscriptionPlan } from '~/data/types/subscription';
import { State } from '~/data/types/store';

export const useSubscriptionPlans = () => {
  const store = useStore<State>();

  const isLoading = computed(() => store.state.subscription.isLoading);

  const plans = computed(() => store.state.subscription.plans);

  const getPlans = async() => {
    if (!plans.value?.length) {
      await store.dispatch('subscription/getPlans');
    }
  };

  const getPlan = (id: string): SubscriptionPlan | null => {
    const validPlans = plans.value.filter(plan => id === plan.id);
    return validPlans ? validPlans[0] : null;
  };

  return {
    getPlan,
    getPlans,
    isLoading,
    plans,
  };
};
